

const TRANSLATIONS_IT_CH = {
    "email_otp.back":"Indietro",
    "email_otp.enter_email_text":"Inserisci il tuo indirizzo e-mail qui sotto per ricevere un codice univoco.",
    "email_otp.send_verification_link":"Invia codice di verifica",
    "email_otp.resend_otp_with_timer":"Invia nuovo codice temporaneo in",
    "email_otp.text":"Abbiamo inviato un codice di verifica a 6 cifre all’indirizzo e-mail [email]. Inserisci il codice qui sotto",
    "email_otp.verify":"Verifica",
    "reset_password.set_password":"Imposta la password",
    "sign_in.or":"o",
    "sign_in.continue_with":"Oppure continua con",
    "sign_in.continue_with_email":"Oppure continua con l’e-mail",
    "sign_in.create_without_password":"Crea un account senza password",
    "sign_in.create_with_otp":"Crea un account con codice di accesso temporaneo",
    "sign_in.login_with_otp":"Accedi con codice di accesso temporaneo",
    "sign_in.login_without_password":"Accedi senza password",
    "sign_in.tooltip_text":"Riceverai un codice di verifica univoco temporaneo tramite e-mail per accedere al tuo account.",
    "sign_up.tooltip_text":"Riceverai un codice di verifica univoco temporaneo tramite e-mail per creare un account.",
    "sign_in.password_updated":"La tua password è stata aggiornata.",
    "sign_up.create_an_account":"Crea un account",
    "email_otp.resend_otp":"Invia nuovo codice temporaneo",
    "sign_up.email_address":"Indirizzo e-mail",
    "sign_up.password":"Password",
    "sign_in.create_account" : "Crea un account",
    "sign_in.title": "Accedi",
    "sign_in.forgot_password" : "Hai dimenticato la password?",
    "reset_password.resend_email": "Invia di nuovo l'email",
    "reset_password.sent_title": "Abbiamo inviato una richiesta all’indirizzo email indicato!",
    "reset_password.rcvResetLink": "Inserisci qui il tuo indirizzo email, ti invieremo un link per ripristinare la password.",
    "reset_password.submit": "Invia",
    "reset_password.back_to_login": "Torna alla pagina di accesso",
    "reset_password.create_new_password": "Crea una nuova password per accedere al tuo profilo.",
    "forgot_password.emailSent": "Se l’indirizzo email inserito [] risulta associato ad un account, riceverai via email un link per reimpostare la password. Non hai ancora ricevuto l'email? Richiedi un nuovo invio.",
    "gdpr.continue": "Continua",
    "validation.password_validation_heading": "Le password devono comprendere:",
    "validation.password_length_ui": "Almeno 8 caratteri",
    "validation.password_upper_case_ui": "una maiuscola",
    "validation.password_lower_case_ui": "una minuscola",
    "validation.password_number_ui": "un numero",
    "validation.password_symbol_ui": "un carattere speciale",
    "verify_otp.customer_service_center_link": "s/contattaci",
    "activate_user.verification_successful.message": "Congratulazioni! Il tuo account è stato attivato.",
    "activate_user.already_verified.message" : "Ti diamo nuovamente il benvenuto! Il tuo account è già stato verificato.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Compila tutti i campi obbligatori prima di procedere.",
    "sign_in.invalid_email_error": "Inserisci l’indirizzo e-mail nel formato corretto, per es.: nome@dominio.com",
    "sign_in.invalid_credentials_error": "Hai inserito un nome utente o una password non validi. Ritenta.",
    "sign_in.generic_error": "Qualcosa è andato storto. Ritenta.",
    "sign_in.account_unverified_error": "Il tuo account non è ancora attivo. Segui il link di attivazione ricevuto via e-mail oppure fai clic su “Hai dimenticato la password?” per reimpostare le tue credenziali.",
    "sign_in.max_attempt_error": "Hai effettuato il numero massimo di tentativi. Riprova più tardi.",
    "sign_in.social_signin_error": "Accesso tramite social (Google/Facebook/Apple) non riuscito. Ritenta o scegli un’altra modalità di accesso.",
    "sign_in.social_signin_email_not_present_error": "Accesso non riuscito. Ritenta o scegli un'altra opzione per l'accesso.",
    "sign_in.guest_user_signin_error": "Questo indirizzo e-mail risulta già associato al tuo account. Fai clic su “Hai dimenticato la password?” per reimpostare le tue credenziali.",

    "sign_up.mandatory_field_error": "Compila tutti i campi obbligatori prima di procedere.",
    "sign_up.invalid_email_error": "Inserisci un indirizzo e-mail valido, per es.: nome@dominio.com",
    "sign_up.password_length_error": "La password deve contenere almeno 8 caratteri.",
    "sign_up.email_already_exist_error": "Indirizzo e-mail già esistente. Usa un altro indirizzo e-mail.",
    "sign_up.generic_error": "Qualcosa è andato storto. Ritenta.",
    "sign_up.password_policy_error": "La password deve contenere un numero, un carattere speciale [!#$%&'*+-/=?^_`{|}~.@], maiuscole e minuscole.",
    "sign_up.common_password_error": "La password non può corrispondere al tuo indirizzo email.",

    "forgot_password.mandatory_field_error": "Compila tutti i campi obbligatori prima di procedere.",
    "forgot_password.invalid_email_error": "Inserisci l’indirizzo e-mail nel formato corretto, per es.: nome@dominio.com",
    "forgot_password.generic_error": "Qualcosa è andato storto. Ritenta.",

    "reset_password.mandatory_field_error": "Compila tutti i campi obbligatori prima di procedere.",
    "reset_password.password_history_error": "La password deve essere diversa dalle ultime cinque.",
    "reset_password.password_length_error": "La password deve contenere almeno 8 caratteri.",
    "reset_password.password_policy_error": "La password deve contenere un numero, un carattere speciale [!#$%&'*+-/=?^_`{|}~.@], maiuscole e minuscole.",
    "reset_password.common_password_error": "La password non può corrispondere al tuo indirizzo email.",
    "reset_password.generic_error": "Qualcosa è andato storto. Ritenta.",

    "email_otp.email_required_error": "Inserisci il tuo indirizzo e-mail per continuare.",
    "email_otp.invalid_email_error": "Inserisci un indirizzo e-mail valido, per es.: nome@dominio.com",
    "email_otp.generic_error": "Qualcosa è andato storto. Riprova più tardi.",
    "email_otp.invalid_otp_error": "Il codice temporaneo/di verifica inserito non è valido. Ritenta.",
    "email_otp.resend_otp_error": "Impossibile inviare nuovamente il codice temporaneo. Riprova più tardi.",
    "email_otp.verify_otp_error": "Qualcosa è andato storto. Ripeti la verifica con codice temporaneo più tardi.",
    "email_otp.verify_otp_limit_exceed_error": "Il codice temporaneo inserito non è valido. Fai clic su “Invia nuovo codice” per riceverne uno nuovo.",
    "email_otp.max_attempt_reached_error": "Hai effettuato il numero massimo di tentativi. Riprova più tardi.",
    "email_otp.brute_force_error_part_1": "Il tuo account è stato temporaneamente bloccato per via dei troppi tentativi di accesso non riusciti. Riprova più tardi oppure ",
    "email_otp.brute_force_error_part_2": "contatta il nostro Centro assistenza",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "Effettuando l’accesso, acconsenti ai nostri",
    "form.termsCondition": "Termini e condizioni",

    //Page Titles
    "sign_in.page_title": "Registrati | Pens.com",
    "sign_up.page_title": "Iscriviti | Pens.com",
    "forgot-password.page_title": "Ha Dimenticato La Password | Pens.com",
    "reset-password.page_title": "Reimposta Password | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_IT_CH;